import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const cards = document.querySelectorAll( '.sticky-process-cards__card' );
      if ( !cards.length ) return;

      function equalizeCardHeights() {
        cards.forEach( ( card ) => card.style.minHeight = '' );
        const maxHeight = Math.max( ...Array.from( cards ).map( ( card ) => card.offsetHeight ) );
        cards.forEach( ( card ) => card.style.minHeight = `${maxHeight}px` );
      }

      equalizeCardHeights();

      const debouncedEqualize = new app.components.common.Debounce( equalizeCardHeights, 250 );
      window.addEventListener( 'resize', () => debouncedEqualize.run() );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'sticky-process-cards', COMPONENT );
} )( app );
